import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, isDevMode } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
// Models
import { IBatch } from '../models/batches/batch';
import { BatchCreateResult, BatchResult, BatchListResult, BatchDeleteResult } from '../models/batches/batch-result';
import { BatchNew } from '../models/batches/batchNew';
import { IUserProfile } from '../models/users/userProfile';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    Accept: 'application/json',
  }),
};
@Injectable({
  providedIn: 'root',
})
export class BatchesService {
  // Observable string sources
  private batchData = new Subject<IBatch>();
  // Observable string streams
  batchData$ = this.batchData.asObservable();

  constructor(private http: HttpClient) {}
  currentBatch!: IBatch;
  private url = `${environment.apiBase}/batches`;

  // Set Current
  setCurrentBatch(batch: IBatch) {
    this.batchData.next(batch);
    this.currentBatch = batch;
  }
  // Get Current Job
  getCurrentBatch(): IBatch {
    return this.currentBatch;
  }

  detailsBatch(batchId: string): Observable<BatchResult> {
    if (isDevMode()) {
      console.log('[DEV] [BatchesService] loading batch details', batchId);
    }
    const url = `${environment.apiBase}/batches/${batchId}`;
    return this.http.get<BatchResult>(url, httpOptions);
  }

  createBatch(newJob: BatchNew): Observable<BatchCreateResult> {
    if (isDevMode()) {
      console.log('[DEV] [BatchesService] creating batch');
    }
    return this.http.post<BatchCreateResult>(this.url, newJob, httpOptions);
  }

  deleteBatch(batch: IBatch): Observable<BatchDeleteResult> {
    if (isDevMode()) {
      console.log('[DEV] [BatchesService] deleting batch', batch.id);
    }
    const url = `${environment.apiBase}/batches/${batch.id}`;
    return this.http.delete<BatchDeleteResult>(url, httpOptions);
  }

  updateBatch(batch: IBatch): Observable<BatchResult> {
    const url = `${environment.apiBase}/batches/${batch.id}`;
    if (isDevMode()) {
      console.log('[DEV] [BatchesService] updating batch', batch.id);
    }
    return this.http.put<BatchResult>(url, batch, httpOptions);
  }

  listBatches(isFavorite?: boolean, count?: number): Observable<BatchListResult> {
    const url = `${environment.apiBase}/batches${this.buildListParams(isFavorite, count)}`;
    if (isDevMode()) {
      console.log('[DEV] [BatchesService] loading batches');
    }
    return this.http.get<BatchListResult>(url, httpOptions);
  }

  updateUsersBatchTags(
    tagIds: string[],
    include: boolean,
    userId: string,
  ): Observable<IUserProfile> {
    const url = `${environment.apiBase}/users/${userId}/batchTags`;
    if (isDevMode()) {
      console.log('[DEV] [BatchesService] updating user batch tags');
    }
    const body = {
      tagIds: tagIds,
      includeFilteredBatches: include,
    };
    return this.http.post<IUserProfile>(url, body, httpOptions);
  }

  favoriteBatch(batch: IBatch): Observable<any> {
    if (isDevMode()) {
      console.log('[DEV] [BatchesService] toggling batch favorite', batch.id);
    }
    const url = `${environment.apiBase}/users/favourites/batches/${batch.id}`;
    return this.http.post<any>(url, httpOptions);
  }

  shareBatch(batchId: string): Observable<void> {
    const url = `${environment.apiBase}/batches/${batchId}/share`;
    return this.http.post<void>(url, {}, httpOptions);
  }

  unShareBatch(batchId: string): Observable<void> {
    const url = `${environment.apiBase}/batches/${batchId}/share`;
    return this.http.delete<void>(url, httpOptions);
  }

  private buildListParams(isFavorite?: boolean, count?: number): string {
    const params: string[] = [];
    if (isFavorite) {
      params.push('isFavourite=true');
    }
    if (count) {
      params.push(`count=${count}`);
    }
    return params.length > 0 ? `?${params.join('&')}` : '';
  }
}
